// Hard-linked players: tags pinned to a specific event, overriding the
// time-based active event. Each group maps a set of player tags to one event id.
//
// NOTE: this mapping is independent of event visibility. Whether an event is
// hidden from the general/time-based selectors is controlled separately by
// HIDDEN_EVENT_IDS in utils/constants.js (currently only the preseason event).
// A mapped event need not be hidden (the June event, now disabled, was not).
//
// The mapped events must be kept `status: active` so they're loadable. See
// layouts/default.vue (the bypass that applies this mapping during initialLoad).
//
// Tags are matched case- and `#`-sensitively, so keep the `#` prefix and casing.

const PRESEASON_EVENT_ID = '9b21b76a-5312-11f1-8044-b2c1dd9dfaf6'
// June event is over — mapping disabled below. Re-enable the group in
// HARD_MAPPED_EVENTS (and this const) when it's needed again.
// const JUNE_EVENT_ID = '0798aaf4-55ff-11f1-86cc-fe5eaffdc674'
// August event is over — mapping disabled below. Re-enable the group in
// HARD_MAPPED_EVENTS (and this const) when it is needed again.
// const AUGUST_EVENT_ID = 'dd90c532-8a35-11f1-a64b-5ad43cfd8ec3'

export const HARD_MAPPED_EVENTS = [
	{
		eventId: PRESEASON_EVENT_ID,
		playerTags: [
			'#LC02JGC8U',
			'#QPQRJQ0V9',
			'#Q0YLLQLVV',
			'#LYG0LQ2L8',
			'#QJCVCQVL9',
			'#LLQ8U29VC',
			'#LUPUYJQVC',
			'#QCVUUUC20',
			'#QCVQQJURY',
			'#9VVYQYR2R',
		],
	},
	// August event is over — re-enable this group (and AUGUST_EVENT_ID above) to
	// restore the hard-coded mappings.
	// {
	// 	eventId: AUGUST_EVENT_ID,
	// 	// One group covers both levels: the pin is event-level, and the TH segment
	// 	// is resolved per player from clanThLevel in event/setActiveSegmentForEvent.
	// 	playerTags: [
	// 		// TH18 (MF Aug 29-31)
	// 		'#PPVYC88R',
	// 		'#V9P9LCLP',
	// 		'#2L900RGVC',
	// 		'#ULJY9LV9',
	// 		'#PPCRRR0',
	// 		'#QCY9PYRV',
	// 		'#GGGYQVV8',
	// 		'#2GJ0Y0PQ',
	// 		'#8J2YCG008',
	// 		'#8CVGGPJY',
	// 		'#8GRV0PGGP',
	// 		'#8L8G2VV8',
	// 		'#28CYPUJGU',
	// 		'#9LJ8UGC9L',
	// 		'#LR82GYQJ',
	// 		'#92YC9J2UY',
	// 		'#RUV0C2JR',
	// 		'#2GRVG9Y8Q',
	// 		'#2C8JPPPYG',
	// 		'#2VQPVRLRJ',
	// 		'#QYRV9Q2G',
	// 		'#2LPPPU0UG',
	// 		'#YVQCP9LR',
	// 		'#2JJVP9G2',
	// 		'#QRUU9QGU',
	// 		'#9288YY0J',
	// 		'#CU2L2RUG',
	// 		'#RYL89PVR',
	// 		'#UY8GGGV9',
	// 		'#Y8JR0PCR',
	// 		'#Q00Q0G2U2',
	// 		'#RUG8GP2',
	// 		'#LJ28UCGQ9',
	// 		'#Y9JGQJGYR',
	// 		'#LCCJL089G',
	// 		'#RRR2889',
	// 		'#PYCYQPRLV',
	// 		'#PUPGPGLG0',
	// 		'#8LRLGQ8G',
	// 		'#LV0Q2VU0',
	// 		// TH15 unpinned 2026-08-29: the TH15 MF (Aug 28 16:00 - Aug 29 07:00) is
	// 		// finished, so those 24 players now follow the time-based event and can
	// 		// register for September. TH18 stays pinned until its MF ends Aug 31.
	// 	],
	// },
	// June event is over — re-enable this group (and JUNE_EVENT_ID above) to
	// restore the hard-coded mappings.
	// {
	// 	eventId: JUNE_EVENT_ID,
	// 	playerTags: [
	// 		'#PPCRRR0',
	// 		'#V9P9LCLP',
	// 		'#2L900RGVC',
	// 		'#PPVYC88R',
	// 		'#ULJY9LV9',
	// 		'#QYRV9Q2G',
	// 		'#2JJVP9G2',
	// 		'#YVQCP9LR',
	// 		'#2LPPPU0UG',
	// 		'#QRUU9QGU',
	// 		'#9RGLCULUG',
	// 		'#9PQ0VUYYL',
	// 		'#LLC02CULL',
	// 		'#9PUJU2YYP',
	// 		'#PYLG0RPGJ',
	// 		'#P2900VULL',
	// 		'#QL2VRQGU0',
	// 		'#LLPGYR0LU',
	// 		'#Q08QVYL9',
	// 		'#QVJPCQV0J',
	// 		'#29UY0UJ29',
	// 		'#PJRUY20R9',
	// 		'#92VL89LLJ',
	// 		'#9PLP0UPQP',
	// 		'#8Y8R922VU',
	// 		'#QCY9PYRV',
	// 		'#GGGYQVV8',
	// 		'#2GJ0Y0PQ',
	// 		'#8J2YCG008',
	// 		'#8CVGGPJY',
	// 		'#80LRQJQUU',
	// 		'#8CL8CV0GV',
	// 		'#8080RPGYP',
	// 		'#288UYQ8GY',
	// 		'#8CUG0JGQG',
	// 		'#YGUYRYV8',
	// 		'#UQUPQ9GG',
	// 		'#29J0GY8VL',
	// 		'#JPGV2C2L',
	// 		'#9JG8UVL0',
	// 	],
	// },
]

// Lookup: player tag -> mapped event id (undefined for non-mapped players).
export const eventIdByPlayerTag = HARD_MAPPED_EVENTS.reduce((acc, { eventId, playerTags }) => {
	playerTags.forEach((tag) => {
		acc[tag] = eventId
	})
	return acc
}, {})
